interface QtySelectorProps
{
    quantity: number
    onQuantityChange: (newQuant: number) => void,
    disableInputs?: boolean,
    maxValue: number,
    minValue: number
}


const QtySelector = (props: QtySelectorProps) =>
{

    const changeQuantity = (adj: number) => 
    {
        props.onQuantityChange(props.quantity + adj);
    }

    const isOrderingEnabled = () => 
    {
        if (props.disableInputs)
        {
            return {
                incrementerEnabled: false,
                decrementerEnabled: false
            }
        }
        return {
            incrementerEnabled: props.quantity < props.maxValue,
            decrementerEnabled: props.quantity > props.minValue
        }
    }

    return(
        <div>
            <button
                className='colPanel-button'
                disabled={!isOrderingEnabled().decrementerEnabled}
                onClick={() => {
                    changeQuantity(-1);
                }}>-
            </button>
            <b className='colPanel-inline'>{props.quantity}</b>
            <button
                className='colPanel-button'
                disabled={!isOrderingEnabled().incrementerEnabled}
                onClick={() => {
                    changeQuantity(1);
                }}>+
            </button>
        </div>)
}

export default QtySelector;